
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/guides/how-to-find-the-right-ibc-channel-for-transfers",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/guides/how-to-find-the-right-ibc-channel-for-transfers/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/guides/how-to-find-the-right-ibc-channel-for-transfers"])
      });
    }
  